import axios from "axios";

export default {
    namespaced: true,

    state: {
        roles: [],
        employee: null,
    },

    mutations: {
        getRolesSuccess(state, roles) {
            state.roles = roles;
        },
    },

    actions: {
        getRoles({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/employees/get-roles")
                    .then((res) => {
                        commit("getRolesSuccess", res.data.data.roles);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getSchedulesData({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/employees/${id}/schedules-data`)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/employees/${id}`)
                    .then((res) => {
                        resolve(res.data.data.employee);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/employees", data)
                    .then((res) => {
                        resolve(res.data.data.employee);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/employees/${data.get("id")}`, data, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res.data.data.employee);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, userId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/employees/${userId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ commit }, userId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/employees/${userId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        roles: (state) => state.roles,
        employee: (state) => state.employee,
    },
};
